// extracted by mini-css-extract-plugin
module.exports = {"container_tabs":"tabs_container_tabs__hQIfQ","container_tabs_hidden":"tabs_container_tabs_hidden__12DkP","active":"tabs_active__3ZPTt","disabled":"tabs_disabled__3sVFo"};